var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.582 16.52C19.1452 14.7078 20.0035 12.3933 20 10C20.0035 7.60676 19.1452 5.29225 17.582 3.48001L13.309 7.75201C13.7605 8.41463 14.0014 9.19818 14 10C14.0014 10.8018 13.7605 11.5854 13.309 12.248L17.582 16.52ZM16.52 17.582C14.7078 19.1452 12.3933 20.0035 10 20C7.60676 20.0035 5.29225 19.1452 3.48001 17.582L7.75201 13.309C8.41463 13.7605 9.19818 14.0014 10 14C10.8018 14.0014 11.5854 13.7605 12.248 13.309L16.52 17.582ZM2.41801 16.52L6.69101 12.248C6.23955 11.5854 5.9987 10.8018 6.00001 10C6.00001 9.16601 6.25501 8.39301 6.69101 7.75201L2.41801 3.47901C0.854628 5.29151 -0.00374061 7.60641 1.2254e-05 10C-0.00350021 12.3933 0.854854 14.7078 2.41801 16.52ZM10 6.00001C9.16601 6.00001 8.39301 6.25501 7.75201 6.69101L3.47901 2.41801C5.29151 0.854628 7.60641 -0.00374061 10 1.2254e-05C12.3933 -0.00350021 14.7078 0.854854 16.52 2.41801L12.248 6.69101C11.5854 6.23955 10.8018 5.9987 10 6.00001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.49104e90e7d7251a23e5a9fbd63a3f77.svg";
export { ForwardRef as ReactComponent };